import React from "react";
import logo from "../../Images/Logo.svg";
import Award from "../../Images/Award.svg";
import Square from "../../Images/Square.svg";
import Red_Square from "../../Images/red_square.svg";
import Sign from "../../Images/Sign.svg";
import Certificate_border from "../../Images/certificate border.svg";

export default function CertificateCard({
  userName,
  courseName,
  completionDate,
  duration,
  course_start_date,
  course_end_date,
}) {
  return (
    <div className="min-h-screen p-8 flex items-center justify-center">
      {/* Certificate */}
      <div className="relative w-[689px] h-[486px] bg-[#273961] overflow-hidden">
        {/* Inner border frame */}
        <div className="absolute left-[22px] top-[15px] w-[648px] h-[455px]" />

        {/* Decorative dots - Right side */}
        {Array.from({ length: 42 }).map((_, i) => (
          <img
            key={`right-${i}`}
            src={Square}
            alt=""
            className="absolute w-2.5 h-2.5"
            style={{ left: "657.5px", top: `${16.97 + i * 10.82}px` }}
          />
        ))}

        {/* Decorative dots - Left side */}
        {Array.from({ length: 42 }).map((_, i) => (
          <img
            key={`left-${i}`}
            src={Square}
            alt=""
            className="absolute w-2.5 h-2.5"
            style={{ left: "22.13px", top: `${16.97 + i * 10.82}px` }}
          />
        ))}

        {/* Decorative dots - Top */}
        {Array.from({ length: 57 }).map((_, i) => (
          <img
            key={`top-${i}`}
            src={Square}
            alt=""
            className="absolute w-2.5 h-2.5"
            style={{ left: `${31.92 + i * 10.98}px`, top: "16.89px" }}
          />
        ))}

        {/* Decorative dots - Bottom */}
        {Array.from({ length: 57 }).map((_, i) => (
          <img
            key={`bottom-${i}`}
            src={Square}
            alt=""
            className="absolute w-2.5 h-2.5"
            style={{ left: `${31.92 + i * 10.98}px`, top: "460.38px" }}
          />
        ))}

        {/* White content area */}
        <div className="absolute left-[31.42px] top-[25.63px] w-[626px] min-h-[435px] bg-zinc-100" />

        {/* Red border frame - overlays on white area */}
        <img
          src={Certificate_border}
          alt="certificatecard"
          className="absolute left-[31.42px] top-[25.63px] w-[626px] h-[435px]"
        />

        {/* Logo placeholder - Left */}
        <div className="absolute left-[76px] top-[65px] w-32 h-80 overflow-hidden">
          <div className="absolute left-[5px] top-[107px] w-28 h-40">
            <img
              src={Award}
              alt="Award"
              className="w-full h-full object-cover"
            />
          </div>
          <div className="absolute left-0 top-0 w-32 h-8 flex items-center justify-center text-xs text-gray-600">
            <img src={logo} alt="Logo" />
          </div>
        </div>

        {/* Certificate Title */}
        <div
          className="absolute left-[356px] top-[64px] text-slate-700 text-4xl font-light text-center"
          style={{ fontFamily: "Oswald" }}
        >
          Certificate
        </div>
        <div
          className="absolute left-[380px] top-[96px] text-stone-900 text-base font-light tracking-wide text-center"
          style={{ fontFamily: "Oswald" }}
        >
          of Achievement
        </div>

        {/* Presented To */}
        <div className="absolute left-[248px] top-[137px] text-black text-xl font-normal uppercase tracking-wide text-center">
          This Certificate is Presented To
        </div>

        {/* Recipient Name */}
        <div
          className="absolute left-[322px] top-[196px] text-black text-3xl font-normal capitalize text-center"
          style={{ fontFamily: "serif" }}
        >
          {userName}
        </div>

        {/* Underline */}
        <div className="absolute left-[266px] top-[226px] w-80 h-0.5 bg-black" />

        {/* Description */}
        <div className="absolute left-[250px] top-[253px] w-80 h-16 text-center">
          <span className="text-neutral-700 text-sm font-normal leading-5">
            by SkillsMD for the successful completion of the <br />
          </span>
          <span className="text-neutral-700 text-sm font-bold leading-5">
            {courseName} Program,
          </span>
          <span className="text-neutral-700 text-sm font-normal leading-5">
            {" "}
            conducted over a period of {course_start_date} to {course_end_date}.
          </span>
        </div>

        {/* Date Section - UPDATED WITH UNDERLINE AND LABEL */}
        <div className="absolute left-[240px] top-[365px]">
          {/* Date text with cursive font */}
          <div
            className="text-black text-xl font-normal text-center mb-1"
            style={{ fontFamily: "Allura"}}
          >
            {completionDate}
          </div>
          {/* Date underline */}
          <div className="w-32 h-0.5 bg-black mb-1 mx-auto"></div>
          {/* DATE label */}
          <div className="text-black text-xs font-normal text-center tracking-widest">
            DATE
          </div>
        </div>

        {/* Signature Section - UPDATED WITH UNDERLINE AND LABEL */}
        <div className="absolute left-[490px] top-[365px]">
          {/* Signature image with cursive style */}
          <div className="w-32 h-8 flex items-center justify-center mb-1">
            <img src={Sign} alt="Signature" className="h-full object-contain" />
          </div>
          {/* Signature underline */}
          <div className="w-32 h-0.5 bg-black mb-1"></div>
          {/* SIGNATURE label */}
          <div className="text-black text-xs font-normal text-center tracking-widest">
            SIGNATURE
          </div>
        </div>
      </div>
    </div>
  );
}